import { Pipe, PipeTransform, NgModule } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyArray = any[];

@Pipe({ name: 'orderBy', standalone: false })
export class OrderByPipe implements PipeTransform {
  /**
   * Sorts an array by a given config
   * @param input - The array to sort
   * @param config - Sort config: '+prop', '-prop', 'prop', or array of those
   * @returns Sorted array copy
   */
  transform(input: AnyArray | undefined | null, config: string | string[] = '+'): AnyArray {
    if (!Array.isArray(input)) {
      return input as any;
    }

    const configIsArray = Array.isArray(config);

    if (!configIsArray || (configIsArray && config.length === 1)) {
      const propertyToCheck = configIsArray ? config[0] : config;
      const first = propertyToCheck.slice(0, 1);
      const desc = first === '-';

      if (!propertyToCheck || propertyToCheck === '-' || propertyToCheck === '+') {
        return [...input].sort((a, b) => {
          const comparator = OrderByPipe.orderBy(a, b);
          return desc ? -comparator : comparator;
        });
      } else {
        const property = first === '+' || desc ? propertyToCheck.slice(1) : propertyToCheck;
        return [...input].sort((a, b) => {
          const comparator = OrderByPipe.orderBy(a[property], b[property]);
          return desc ? -comparator : comparator;
        });
      }
    } else {
      return [...input].sort((a, b) => {
        for (let i = 0; i < config.length; ++i) {
          const first = (config as string[])[i].slice(0, 1);
          const desc = first === '-';
          const property = first === '+' || desc ? (config as string[])[i].slice(1) : (config as string[])[i];
          const comparator = OrderByPipe.orderBy(a[property], b[property]);
          const comparison = desc ? -comparator : comparator;
          if (comparison !== 0) {
            return comparison;
          }
        }
        return 0;
      });
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private static orderBy(a: any, b: any): number {
    if (a instanceof Date && b instanceof Date) {
      return a < b ? -1 : a > b ? 1 : 0;
    }
    const floatA = parseFloat(a);
    const floatB = parseFloat(b);
    if (typeof a === 'string' && typeof b === 'string' && (isNaN(floatA) || isNaN(floatB))) {
      const lowerA = a.toLowerCase();
      const lowerB = b.toLowerCase();
      return lowerA < lowerB ? -1 : lowerA > lowerB ? 1 : 0;
    }
    return floatA < floatB ? -1 : floatA > floatB ? 1 : 0;
  }
}

@NgModule({
  declarations: [OrderByPipe],
  exports: [OrderByPipe],
})
export class NgOrderByPipeModule {}
